/* @flow */
import invariant from 'fbjs/lib/invariant';
export default invariant;
